import { render } from "./RightsIssue2026.vue?vue&type=template&id=7411f0b8&scoped=true"
import script from "./RightsIssue2026.vue?vue&type=script&lang=js"
export * from "./RightsIssue2026.vue?vue&type=script&lang=js"

import "./RightsIssue2026.vue?vue&type=style&index=0&id=7411f0b8&lang=scss&scoped=true"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7411f0b8"]])

export default __exports__